import { red } from "@material-ui/core/colors"
import { createMuiTheme } from "@material-ui/core/styles"

declare module "@material-ui/core/styles" {
  interface Palette {
    appContainerBackground: string
  }

  interface PaletteOptions {
    appContainerBackground: string
  }
}

const auroraPayTheme = createMuiTheme({
  typography: {
    fontFamily: [
      "Gilroy",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: {
      main: "#00aab5",
      dark: "#4586c6",
    },
    secondary: {
      main: "#ec008c",
      dark: "#458B89",
      light: "#f9ffff",
    },
    error: {
      main: "#ff0000c9",
    },
    background: {
      default: "#fff",
    },
    text: {
      primary: "#00aab5",
      secondary: "#001423",
    },
    info: {
      main: "#63C7C5",
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        borderRadius: "1px",
        padding: "15px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "12pt",
        width: "200px;",
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
      },
      text: {
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "12pt",
      },
    },
  },
})

export default auroraPayTheme
